import HTTP from './HTTPApi';

const URL_BASE = 'user';

export async function GetUser(id) {
  const response = await HTTP.get(`${URL_BASE}/GetOne/${id}`);
  return response;
}

export async function GetTokenUser(id) {
  const response = await HTTP.get(`${URL_BASE}/GetTokenUser/${id}`);
  return response;
}

export async function Create(data) {
  const response = await HTTP.post(`${URL_BASE}/Create`, data);
  return response;
}

export async function Update(id, data) {
  const response = await HTTP.put(`${URL_BASE}/Update/${id}`, data);
  return response;
}

export async function GetAll(params) {
  const response = await HTTP.get(`${URL_BASE}/GetAll`, { params });
  return response;
}

export async function DeleteOne(id) {
  const response = await HTTP.delete(`${URL_BASE}/DeleteOne/${id}`);
  return response;
}

export const NOTHING = '';
